(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('[data-lyl-track]');
    if (!tracks.length) return;

    var productsPromise = null;

    function loadAllProducts() {
      if (productsPromise) return productsPromise;
      productsPromise = fetch('/products.json?limit=250')
        .then(function (r) {
          if (!r.ok) throw new Error('products.json failed');
          return r.json();
        })
        .then(function (d) {
          return (d && d.products) || [];
        })
        .catch(function () {
          return [];
        });
      return productsPromise;
    }

    function shuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }
      return arr;
    }

    function formatMoney(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      return '$' + n.toFixed(2);
    }

    function imgUrl(src, width) {
      if (!src) return '';
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      return src + sep + 'width=' + width;
    }

    function buildCard(product) {
      var variant = product.variants && product.variants[0];
      if (!variant) return null;

      var price = variant.price;
      var compare = variant.compare_at_price;
      var onSale = compare && parseFloat(compare) > parseFloat(price);
      var img0 = product.images && product.images[0];
      var img1 = product.images && product.images[1];

      var article = document.createElement('article');
      article.className = 'lyl-card';

      var link = document.createElement('a');
      link.className = 'lyl-card-link';
      link.href = '/products/' + product.handle;

      var wrap = document.createElement('div');
      wrap.className = 'lyl-image-wrap';

      if (img0 && img0.src) {
        var primary = document.createElement('img');
        primary.className = 'lyl-image lyl-image--primary';
        primary.src = imgUrl(img0.src, 600);
        primary.srcset =
          imgUrl(img0.src, 400) + ' 400w, ' +
          imgUrl(img0.src, 600) + ' 600w, ' +
          imgUrl(img0.src, 800) + ' 800w';
        primary.sizes = '(max-width: 749px) 62vw, 25vw';
        primary.alt = product.title || '';
        primary.loading = 'lazy';
        primary.width = 600;
        primary.height = 800;
        wrap.appendChild(primary);
      }

      if (img1 && img1.src) {
        var hover = document.createElement('img');
        hover.className = 'lyl-image lyl-image--hover';
        hover.src = imgUrl(img1.src, 600);
        hover.alt = '';
        hover.loading = 'lazy';
        hover.width = 600;
        hover.height = 800;
        hover.setAttribute('aria-hidden', 'true');
        wrap.appendChild(hover);
      }

      if (onSale) {
        var badge = document.createElement('span');
        badge.className = 'lyl-badge';
        badge.textContent = 'Sale';
        wrap.appendChild(badge);
      }

      var info = document.createElement('div');
      info.className = 'lyl-info';

      var title = document.createElement('h3');
      title.className = 'lyl-product-title';
      title.textContent = product.title || '';
      info.appendChild(title);

      var priceRow = document.createElement('div');
      priceRow.className = 'lyl-price-row';

      if (onSale) {
        var sale = document.createElement('span');
        sale.className = 'lyl-price lyl-price--sale';
        sale.textContent = formatMoney(price);
        priceRow.appendChild(sale);

        var orig = document.createElement('span');
        orig.className = 'lyl-price lyl-price--compare';
        orig.textContent = formatMoney(compare);
        priceRow.appendChild(orig);
      } else {
        var p = document.createElement('span');
        p.className = 'lyl-price';
        p.textContent = formatMoney(price);
        priceRow.appendChild(p);
      }
      info.appendChild(priceRow);

      link.appendChild(wrap);
      link.appendChild(info);
      article.appendChild(link);
      return article;
    }

    function initTrack(track) {
      var currentId = track.getAttribute('data-current-product-id') || '';
      var count = parseInt(track.getAttribute('data-product-count'), 10) || 6;

      loadAllProducts().then(function (products) {
        if (!products || !products.length) {
          var section = track.closest('[data-lyl-section]');
          if (section) section.style.display = 'none';
          return;
        }

        var pool = products.filter(function (p) {
          return String(p.id) !== String(currentId);
        });
        shuffle(pool);

        var picked = pool.slice(0, count);
        var frag = document.createDocumentFragment();
        picked.forEach(function (p) {
          var card = buildCard(p);
          if (card) frag.appendChild(card);
        });

        if (!frag.childNodes.length) {
          var s = track.closest('[data-lyl-section]');
          if (s) s.style.display = 'none';
          return;
        }

        track.innerHTML = '';
        track.appendChild(frag);
      });
    }

    tracks.forEach(initTrack);
  })();

  } catch(e) { console.error(e); }
})();
})();
